export default "__VITE_ASSET__C9INzVVx__"